import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

NProgress.configure({ showSpinner: false })

const whiteList = ['/login.htm', '/forgetPwd.htm', '/forgetResetPwd.htm', '/LogOut.htm', '/welcome.htm', '/register.htm', '/getTmpl.htm','/sso.htm', '/registerWorkshop.htm'] // 不重定向白名单

router.beforeEach((to, from, next) => {
  NProgress.start()
  // 指定连接跳转，缓存参数
  if (to.path === '/stpurl.htm') {
    localStorage.setItem("stpurl", qs.stringify(to.query));
  }
  if (getToken()) {
    if (to.path === '/login.htm' || to.path === '/LogOut.htm') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (store.getters.permission_routes.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          store.dispatch('GenerateRoutes').then(accessRoutes => {
            // 测试 默认静态页面
            // store.dispatch('permission/generateRoutes', { roles }).then(accessRoutes => {
            // 根据roles权限生成可访问的路由表
            router.addRoutes(accessRoutes) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            // Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          }).catch(() => {
            Message.error(err || 'Verification failed, please login again')
          })
        })
      } else {
        // 如果未初始化密码，则强制to到index.htm
        if (store.getters.userInfo.initPwd === 1 && to.path !== '/index.htm') {
          next({ path: '/index.htm' })
          NProgress.done()
        } else {
          /* 路由发生变化修改页面title */
          if (to.meta.title) {
            document.title = to.meta.title;
          }
          next()
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      if(to.path.indexOf('sso')!=-1){
        // 跳转到sso.htm
        next(`/login.htm?redirect=${to.path}`) // 否则全部重定向到登录页
      }else{
        //to welcome.htm page
        next(`/welcome.htm`) 
      }
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js